import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
type RevealHeadingProps = {
  lines: string[];
  /** Single word or phrase tinted with the signature accent, matching the section heading style. */
  accent?: string;
  className?: string;
  as?: "h1" | "h2";
  delay?: number;
  id?: string;
};

/** Splits a line so the accented phrase can be tinted without breaking the mask reveal. */
function renderLine(line: string, accent?: string) {
  if (!accent) return line;
  const start = line.indexOf(accent);
  if (start === -1) return line;
  return <>
      {line.slice(0, start)}
      <span className="text-[#54f6c6]" data-id="element-359" data-mp="2uz7wim3zsssd">{accent}</span>
      {line.slice(start + accent.length)}
    </>;
}

/**
 * Mask reveal. The observer watches the heading itself rather than the translated line,
 * because a line sitting fully outside its overflow-hidden mask never reports as in view.
 */
export function RevealHeading({
  lines,
  accent,
  className = "",
  as = "h2",
  delay = 0,
  id
}: RevealHeadingProps) {
  const ref = useRef<HTMLHeadingElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: "0px 0px -12% 0px"
  });
  const content = lines.map((line, index) => <span key={line} className="block overflow-hidden" data-id="element-360" data-mp="2r4vvp6gkvoth" data-mpi={index}>
      <motion.span className="block" initial={{
      y: "108%"
    }} animate={inView ? {
      y: 0
    } : {
      y: "108%"
    }} transition={{
      duration: 0.85,
      delay: delay + index * 0.08,
      ease: [0.16, 1, 0.3, 1]
    }} data-id="element-361" data-mp="2r5f4nxo932vd">
        {renderLine(line, accent)}
      </motion.span>
    </span>);
  if (as === "h1") {
    return <h1 ref={ref} id={id} className={className} data-id="element-362" data-mp="3aswcxu5k6zkf">
        {content}
      </h1>;
  }
  return <h2 ref={ref} id={id} className={className} data-id="element-363" data-mp="35ubjcdktbe4y">
      {content}
    </h2>;
}